import { Email, EmailWrapper } from "../interfaces/email.interface";

export class EmailWrapperImpl implements EmailWrapper {
    Workaround = "";
    Email: Email[];

    constructor(email: Email[]) {
        this.Email = email;
    }
}

export class EmailImpl implements Email {
    constructor(
        public Name: string,
        public FromName: string,
        public FromAddress: string,
        public LocalDomain: string,
        public ServerAddress: string,
        public ServerPort: string,
        public UserName: string,
        public UserPassword: string,
        public CC: string,
        public CCN: string
    ) {}
}